import { Request as request } from "@/utils/request";

/**
 * 生成 TON 订单
 * @param {number} amount 需要支付的 TON 数量
 * @returns {
 * "code": 200,
 * "data": {
 * "order_id": "xxxx", // 订单号，用于发起 TON 转账
 * "amount": "amount", // 需要支付的 TON 数量
 * "order_hash": "order_hash" // 订单哈希，用于后续创建订单
 * }}
 */
let generateOrder = (amount) => {
  return request("/api/common_v1/ton-generate-order", {
    method: "POST",
    params: { amount },
  });
};

/**
 * 创建 TON 订单
 * @param {{
 * order_id: string,
 * order_hash: string,
 * user_id: string,
 * boc: string,
 * recaptcha_token: string
 * }} params
 * @obj {{
 * code: 200,
 * data: ""
 * }}
 * @returns {Promise<obj>} 返回服务器响应
 *
 */
let createOrder = (params) => {
  return request("/api/common_v1/ton-create-order", {
    method: "POST",
    params,
  });
};

/**
 * 检查 TON 订单状态
 * @param {string} order_id 生成订单返回的订单号
 * @returns {Promise<Object>} 返回服务器响应
 * {
 * "code": 200,
 * "data": "wait" // wait: 等待付款，success: 付款成功
 * }
 */
let checkOrderStatus = (order_id) => {
  return request("/api/common_v1/ton-check-order", {
    method: "POST",
    params: { order_id },
  });
};

/**
 * 创建 TON 订单2
 * @param {{
* id: string,
* }} params
* @obj {{
    "code": 200,
    "data": {
        "order_id": "xxxx", // 订单号
        "url": "xxx" // 付款的钱包地址
    }
}}
* @returns {Promise<obj>} 返回服务器响应
* 
*/
let createOrderV2 = (params) => {
  return request("/api/common_v3/ton-create-order", {
    method: "POST",
    params,
  });
};

/**
 * 检查 TON 订单状态2
 * @param {string} order_id 生成订单返回的订单号
 * @returns {Promise<Object>} 返回服务器响应
 * {
 * "code": 200,
 * "data": "wait" // wait: 等待付款，success: 付款成功
 * }
 */
let checkOrderStatusV2 = (order_id) => {
  return request("/api/common_v3/ton-check-order", {
    method: "POST",
    params: { order_id },
  });
};

/**
 * 提交提现
 * @param {object} params
 * @param {string} params.amount 提现金额
 * @param {string} params.address 地址
 * @returns
 */
let getWithdrawSubmit = (params) => {
  return request("/api/miner/withdrawals-submit-v1", {
    method: "POST",
    params,
  });
};

/**
 * 获取提现列表
 * @returns
 */
let getWithdrawList = () => {
  return request("/api/wallet/withdrawals", {
    method: "GET",
  });
};

/**
 * 商品 stars 星星订单
 * @param {object} params
 * @param {string} params.id 商品id
 * @param {string} params.type 类型 默认为空  现有:single_pay: 单次支付
 * @returns
 */
let getStarsSku = (params, type = "") => {
  let url = "/api/miner/sku-stars";
  if (type) {
    switch (type) {
      case "single_pay":
        url = "/api/step-pay/stars-create-order";
        params.equipment_id = params.id;
        delete params.id;
        break;
    }
  }
  return request(url, {
    method: "POST",
    params,
  });
};

/**
 * 商品 ton 订单
 * @param {object} params
 * @param {string} params.id 商品id
 * @param {string} params.type 类型 默认为空  现有:single_pay: 单次支付
 * @returns
 */
let getTonSku = (params, type = "") => {
  let url = "/api/miner/sku-ton";
  if (type) {
    switch (type) {
      case "single_pay":
        url = "/api/step-pay/ton-create-order";
        params.equipment_id = params.id;
        delete params.id;
        break;
    }
  }
  return request(url, {
    method: "POST",
    params,
  });
};

/**
 * 商品 usdt 订单
 * @param {object} params
 * @param {string} params.id 商品id
 * @param {string} params.type 类型 默认为空  现有:single_pay: 单次支付
 * @returns
 */
let getUsdtSku = (params, type = "") => {
  let url = "/api/miner/sku-usdt";
  if (type) {
    switch (type) {
      case "single_pay":
        url = "/api/step-pay/usdt-create-order";
        params.equipment_id = params.id;
        delete params.id;
        break;
    }
  }
  return request(url, {
    method: "POST",
    params,
  });
};

/**
 * 检查订单状态
 * @param {string} params.id 订单id
 * @returns
 */
let checkOrderV4 = (params) => {
  return request("/api/common_v4/check-order", {
    method: "POST",
    params,
  });
};
/**
 * 佣金提现
 * @param {{
 * amount: number,
 * }} params
 * @returns {Promise<Object>} 返回服务器响应
 */
let commissionSubmit = (params) => {
  return request("/api/common/commission-submit", {
    method: "POST",
    params,
  });
};
/**
 * 佣金提现记录
 * @returns {Promise<Object>} 返回服务器响应
 */
let withdrawalsList = (params) => {
  return request("/api/common/commission-list", {
    method: "POST",
    params,
  });
};

/**
 * 提交提现
 * @param {object} params
 * @param {string} params.amount 提现金额
 * @param {string} params.address 地址
 * @returns
 */
let getWithdrawSubmitV3 = (params) => {
  return request("/api/miner/withdrawals-submit-v4", {
    method: "POST",
    params,
  });
};
// /api/common/convert
/**
 * 兑换
 * @param {object} params
 * @param {string} params.amount 兑换金额
 * @param {string} params.address 兑换地址
 * @param {string} params.token_name 提现币种
 * @param {string} params.share 分享组群数
 * @returns
 */
let convert = async (params, type = "ton") => {
  //如果是xrp，则使用v-2接口
  if (type == "xrp") {
    return request("/api/common/convert-v2", {
      method: "POST",
      params,
    });
  }
  return request("/api/common/convert-v1", {
    method: "POST",
    params,
  });
};
// /api/common/payment-submit POST
// payment_type 钱包类型
// payment_info 钱包地址
/**
 * 提交付款
 * @param {object} params
 * @param {string} params.payment_type 钱包类型
 * @param {string} params.payment_info 钱包地址
 * @returns
 */
let paymentSubmit = (params) => {
  return request("/api/common/payment-submit", {
    method: "POST",
    params,
  });
};
/**
 * 提交付款
 * @param {object} params
 * @param {string} params.payment_type 钱包类型
 * @param {string} params.payment_info 钱包地址
 * @returns
 */
let updatePayment = (params) => {
  return request("/api/common/update-payment", {
    method: "POST",
    params,
  });
};

let acceleratedWithdrawals = (params) => {
  return request("/api/common/accelerated-withdrawals", {
    method: "POST",
    params,
  });
};
export {
  generateOrder,
  createOrder,
  checkOrderStatus,
  createOrderV2,
  checkOrderStatusV2,
  getWithdrawSubmit,
  getWithdrawList,
  getStarsSku,
  getTonSku,
  getUsdtSku,
  checkOrderV4,
  commissionSubmit,
  withdrawalsList,
  getWithdrawSubmitV3,
  convert,
  paymentSubmit,
  updatePayment,
  acceleratedWithdrawals,
};
